import {FormStoppageTypeWithDepartments} from '../types'

/**
 * Minimum duration for a stoppage to be considered as a split stoppage
 * in minutes
 */
export const MIN_SPLIT_STOPPAGE_DURATION = 2

/**
 * RCFA mandatory stoppage duration in seconds (24 hours)
 */
export const RCFA_MANDATORY_STOPPAGE_DURATION = '86400'

/**
 * Mapping of stoppage types to their corresponding department codes
 */
export const DEPARTMENT_BY_TYPE: Record<FormStoppageTypeWithDepartments, string[]> = {
  [FormStoppageTypeWithDepartments.Kiln]: ['40_4', '41_1'],
  [FormStoppageTypeWithDepartments.CementMill]: ['45_1', '50_3', '50_4'],
  [FormStoppageTypeWithDepartments.RawMill]: ['30_4'],
  [FormStoppageTypeWithDepartments.CoalMill]: ['06_4'],
  [FormStoppageTypeWithDepartments.Crusher]: ['20_4']
}
